import servicesData from "../data/servicesData.js";

/**
 * Finds the index of a service by its name (case-insensitive).
 * @param {string} serviceName
 * @returns {number} Index or -1 if not found
 */
export function findServiceIndex(serviceName) {
  return servicesData.findIndex(
    (s) => s.title.toLowerCase() === serviceName.toLowerCase()
  );
}

/**
 * Groups sub-services by their category.
 * @param {Array} subServices
 * @returns {Object} { [category]: subServices[] }
 */
export function groupSubServicesByCategory(subServices) {
  return subServices.reduce((categories, subService) => {
    const category = subService.category || "Other";
    if (!categories[category]) {
      categories[category] = [];
    }
    categories[category].push(subService);
    return categories;
  }, {});
}

/**
 * Extracts the lowest numeric value from a price string.
 * @param {string|number} price
 * @returns {number}
 */
export function extractNumericBTN(price) {
  if (typeof price === "number") return price;
  if (typeof price === "string") {
    const cleaned = price.replace(/,/g, "");
    const match = cleaned.match(/\d+(\.\d+)?/g);
    if (match && match.length > 0) {
      return parseFloat(match[0]);
    }
  }
  return 0;
}
